module.exports = __webpack_public_path__ + "static/sport/bgi-pc.dece8b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/bgi-pc.jpg
// module id = MFB5
// module chunks = 0